import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Swal from "sweetalert2";
import contactImg from "../../assets/image/contact.png";

const onSubmit = async (event) => {
  event.preventDefault();
  const formData = new FormData(event.target);

  formData.append("access_key", "c24ce5ce-4123-4f80-9139-14d5d1d497e3");

  const object = Object.fromEntries(formData);
  const json = JSON.stringify(object);

  const res = await fetch("https://api.web3forms.com/submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: json,
  }).then((res) => res.json());

  if (res.success) {
    Swal.fire({
      title: "Success!",
      text: "Message send succesfully!",
      icon: "success",
    });
  }
};
export const Contact = () => {
  return (
    <section id="contact" className="contact bg-dark py-1 text-white">
      <Container>
        <h1 className="display-1 text-center mb-5 font-bold font-Georgia">
          Contact Us
        </h1>
        <Row className="align-items-center">
          <Col size={12} md={7}>
            <form onSubmit={onSubmit} className="p-4 border rounded bg-white">
              <h2 className="mb-4 text-center">Contact Us</h2>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your First Name"
                  name="firstName"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your Last Name"
                  name="lastName"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your Email ID"
                  name="email"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Enter your Phone no."
                  name="phone"
                  required
                />
              </div>
              <div className="mb-3">
                <textarea
                  name="message"
                  className="form-control"
                  placeholder="Enter your message here"
                  rows="4"
                  required
                />
              </div>
              <button type="submit" className="btn btn-danger w-100">
                Send Message
              </button>
            </form>
          </Col>
          <Col size={12} md={5} className="text-center">
            <img src={contactImg} alt="Contact Us" className="img-fluid mb-4" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
